import Game from 'app/records/game'
import React, { PropTypes } from 'react'
import Strings from 'config/strings'
import TeamGif from '../team-gif'
import { pluralize } from 'lib/strings'

export default React.createClass({

  propTypes: {
    game   : PropTypes.instanceOf(Game).isRequired,
    onNext : PropTypes.func.isRequired
  },

  render() {
    const { game, onNext } = this.props

    return (
      <main className="round-starting fill-black">
        <div className="container">
          <TeamGif team={ Game.getCurrentTeam(game) } short />

          <div className="turn-finished__title">
            Round { game.round } over. Nice Job Ace! You Scored { game.turn_score } { pluralize(game.turn_score, 'card', 'cards') }!
          </div>

          <div className="row">
            <div className="col round-starting__team no-vs fill-blue">
              { game.team_1.name }<br/>
              { game.team_1.score }
            </div>
            <div className="col round-starting__team fill-red">
              { game.team_2.name }<br/>
              { game.team_2.score }
            </div>
          </div>

          { Game.isTie(game) ? this.renderTie() : this.renderWinner(Game.getWinner(game)) }

          <button className="round-starting__submit" onClick={ onNext }>
            { game.round < 3 ? "Start Next Round" : "See Final Results" }
          </button>
        </div>
      </main>
    )
  },

  renderTie() {
    return (
      <div className="turn-finished__title">
        { Strings['game.tie'] }
      </div>
    )
  },

  renderWinner(team) {
    return (
      <div className="turn-finished__title">
        Team { team.name } is killing it!
      </div>
    )
  },


})



/** WEBPACK FOOTER **
 ** ./web/static/app/components/game/phases/round-finished.jsx
 **/